<template>
    <div>
        <div>
            <h3 style="margin-top: 8px; margin-left: 22px; font-size: 18px;">Debit Card</h3>
            <base-input alternative="" label="Debit Card Payment List" input-classes="form-control" style="margin-top: 8px; margin-left: 22px;">
                    <b-row>
                        <b-col>
                            <a-select
                                v-model="menus.selectedPaymentTypes"
                                mode="multiple"
                                style="width: 100%"
                                placeholder="Select Debit/Credit Card Payment"
                                optionFilterProp="children"
                                >
                                    <a-select-option v-for="payment in paymentTypeList"
                                            :key="payment.id"
                                            :value="payment.code">{{ payment.name }}
                                    </a-select-option>
                            </a-select>
                        </b-col>
                        <b-col></b-col>
                        <b-col></b-col>
                    </b-row>
            </base-input>
        </div>
    </div>
    
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import { mapState } from 'vuex'

    let component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId']),
        },
        mounted: async function () {
            component_x = this;

            const payment_type_data = await HTTPRequest.getRequest(this.endPoint + 'payment_types/get_valid_payment_types', null)
            this.paymentTypeList = payment_type_data;
            
            if(this.$attrs.defaultValue != undefined || this.$attrs.defaultValue != null){
                this.menus = this.$attrs.defaultValue
                this.isNewSetting = false
            }
            this.settingCode = this.$attrs.settingCode
        },
          watch: {
            menus: {
                handler: async function(){
                    var configValues = {}
                    configValues[this.settingCode] = this.menus
                    component_x.$emit("changeValue", configValues)
                },
                deep: true
            }
        },
        data() {
            return {
                paymentTypeList: [],
                selectedPaymentTypes: [],
                menus: {},
                settingCode: null,
            }
        },  
    }
</script>
